// @flow
import { getAxiosInstance } from '@rover/utilities/axiosUtils';
import { fullApiUrl } from '@rover/utilities/apiUrl';
import { camelize } from '@rover/utilities/object-utilities';
import type { CountryConfiguration, ExpressParams } from '@rover/react-lib/types';

import DefaultAPIErrorHandler from './DefaultAPIErrorHandler';

export const countryConfigurationsUrl = fullApiUrl('country-configuration/');
export const currentCountryConfigurationUrl = fullApiUrl('country-configuration/current/');
export const navigationCountryConfigurationUrl = fullApiUrl('country-configuration/navigation/');

export const getAll = async (
  expressParams: ?ExpressParams
): Promise<Array<CountryConfiguration>> => {
  const ai = getAxiosInstance(expressParams);
  try {
    const response = await ai.get(countryConfigurationsUrl);
    return camelize(response.data.results, true);
  } catch (error) {
    throw DefaultAPIErrorHandler(error, 'There was an error getting your country configuration.');
  }
};

// Figure out if the /navigation API call can replace /current API call. The /current API does not
// take into account directly visiting country-specific pages such as /uk, /es, etc. This means that
// certain UI elements, like the Language dropdown, do not end up appearing on the country-specific
// pages if the user is currently in the US.
// See DEV-41929
export const getCurrent = async (expressParams: ?ExpressParams): Promise<CountryConfiguration> => {
  const ai = getAxiosInstance(expressParams);
  try {
    const response = await ai.get(currentCountryConfigurationUrl);
    return camelize(response.data, true);
  } catch (error) {
    throw DefaultAPIErrorHandler(
      error,
      'There was an error getting your current country configuration.'
    );
  }
};

export const getNavigation = async (
  expressParams: ?ExpressParams
): Promise<CountryConfiguration> => {
  const ai = getAxiosInstance(expressParams);
  try {
    const response = await ai.get(navigationCountryConfigurationUrl);
    return camelize(response.data, true);
  } catch (error) {
    throw DefaultAPIErrorHandler(
      error,
      'There was an error getting your navigation country configuration.'
    );
  }
};



// WEBPACK FOOTER //
// ../react-lib/src/apis/countryConfiguration.api.js